<template>
  <div class="programs-page">
    <h1 class="programs-title">Our Academy Programs</h1>
    <section class="programs-gallery">
      <div v-for="(program, idx) in programs" :key="idx" class="program-item">
        <img :src="program.image" :alt="program.title" class="program-img" />
        <p class="program-desc">{{ program.title }}</p>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'ProgramsPage',
  data() {
    return {
      programs: [
        { image: 'uryyr.png', title: 'Robotics Programming' },
        { image: '11111.png', title: 'Electronics Basics' },
        { image: '222222.png', title: 'Teamwork Workshops' },
        { image: '3333.png', title: 'Creative Thinking' },
        { image: '44.png', title: 'Coding for Kids' },
        { image: '6884.png', title: 'AI Introduction' },
        { image: '2471.png', title: 'Math & Logic' },
        { image: '84745124.png', title: 'Science Experiments' },
        { image: '5412.png', title: 'Robotics Competitions' },
        { image: '964.png', title: 'Problem Solving' },
        { image: '963669.png', title: 'Innovation Labs' },
        { image: '96325412.png', title: 'Technology Discovery' }
      ]
    };
  }
};



</script>
<style scoped>
.programs-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  font-family: 'Cairo', Arial, sans-serif;
  background: linear-gradient(to bottom, #e3f2fd, #ffffff);
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.programs-title {
  text-align: center;
  font-size: 2.5rem;
  color: #1565c0;
  margin-bottom: 2.5rem;
  font-weight: bold;
}
.programs-gallery {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
}
.program-item {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 1rem;
  transition: transform 0.3s, box-shadow 0.3s;
}
.program-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}
.program-img {
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 1rem;
}
.program-desc {
  font-size: 1.2rem;
  color: #333;
  text-align: center;
  margin: 0;
  font-weight: bold;
}
@media (max-width: 900px) {
  .programs-gallery {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }
  .program-item {
    width: 98vw;
    max-width: 300px;
  }
}
</style>
